/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SceneConfigurationFile
 */
export interface SceneConfigurationFile {
    /**
     * 
     * @type {any}
     * @memberof SceneConfigurationFile
     */
    content?: any | null;
}

export function SceneConfigurationFileFromJSON(json: any): SceneConfigurationFile {
    return SceneConfigurationFileFromJSONTyped(json, false);
}

export function SceneConfigurationFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): SceneConfigurationFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : json['content'],
    };
}

export function SceneConfigurationFileToJSON(value?: SceneConfigurationFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
    };
}

